import { WithItineraryBookings } from '@/travelsuit'

export function getItineraryServices(itinerary: WithItineraryBookings) {
	return [
		...itinerary.flights_bookings,
		...itinerary.hotels_bookings,
		...itinerary.rails_bookings,
		...itinerary.cars_bookings,
	]
}
